<script>
    export let tip;
    import { fade} from 'svelte/transition';

    let loaded = false;

    setTimeout(() => {
        loaded = true;
    }, 200)

</script>

{#if loaded}
<div class="fancybox-outer tip-modal">
    <div class="fancybox-inner tip-modal" style="overflow: auto; max-width: 657px; min-height: 480px; width: 100%" transition:fade>
        <!-- Detail view of Pancake-ism and Tips -->
        <section class="bg-hub-item tip"
                 style="background-image: url({tip.image}); background-size: cover;">
            <div class="inner">
                <h1>{tip.title}</h1>
                <p>{@html tip.content}</p>
            </div>
        </section>
    </div>
</div>
{/if}